import { render, staticRenderFns } from "./UserDashboard.vue?vue&type=template&id=5f878af6&scoped=true&"
import script from "./UserDashboard.vue?vue&type=script&lang=js&"
export * from "./UserDashboard.vue?vue&type=script&lang=js&"
import style0 from "./UserDashboard.vue?vue&type=style&index=0&id=5f878af6&prod&scoped=true&lang=css&"
import style1 from "./UserDashboard.vue?vue&type=style&index=1&id=5f878af6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f878af6",
  null
  
)

export default component.exports